(function() {
  'use strict';

  function Search($translate) {
    var getSearch = function() {
      var search = {
        facetly: {
          facets: [
            {
              id: 'text',
              type: 'search',
              placeholder: $translate.instant('Start typing to search')
            },
            {
              id: 'recipients',
              type: 'text',
              label: $translate.instant('Recipient'),
              facetly: false,
              advanced: true
            },
            {
              id: 'block',
              type: 'select',
              label: $translate.instant('Part'),
              multiselect: true,
              facetly: false,
              advanced: false,
              options: [
                { id: 'events', title: $translate.instant('Events') },
                { id: 'goals', title: $translate.instant('Goals') },
                { id: 'users', title: $translate.instant('Users') },
                { id: 'payments', title: $translate.instant('Payments') },
                { id: 'bookings', title: $translate.instant('Bookings') }
              ]
            },
            {
              id: 'state',
              type: 'select',
              label: $translate.instant('Status'),
              multiselect: true,
              facetly: false,
              advanced: true,
              options: [
                { id: 'pending', title: $translate.instant('Pending') },
                { id: 'delivered', title: $translate.instant('Delivered') },
                { id: 'bounced', title: $translate.instant('Bounced') },
                { id: 'other', title: $translate.instant('Other') }
              ]
            },
            {
              id: 'after',
              type: 'date',
              label: $translate.instant('Sent after'),
              facetly: false,
              advanced: true
            },
            {
              id: 'before',
              type: 'date',
              label: $translate.instant('Sent before'),
              facetly: false,
              advanced: true
            }
          ]
        },
        filters: [
        ],
        orderGroups: {
          name: {
            title: $translate.instant('addedDate'),
            orders: ['addedDate']
          }
        },
        defaultFilter: {
        },
        defaultOrder: 'addedDate'
      };
      return search;
    };

    var service = {
      search: getSearch()
    };

    return service;
  }

  Search.$inject = ['$translate'];

  angular.module('component.emailLogs')
    .service('EmailLogSearch', Search);
})();
